// import Package from '../../../package.json';
export interface Constants {
  APP_NAME: string;
  CURRENCY_NAME: string;
  AGE_REQUIREMENT: number;
}

export const AppData: Constants = {
  APP_NAME: 'Breakroom', //Package.name,
  CURRENCY_NAME: 'gem',
  AGE_REQUIREMENT: 18,
};
